import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';

const state = {
  editorOutlets: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_OUTLETS_BUSY: (state, payload) => {
    state.editorOutlets.isBusy = payload;
  },
  LOAD_OUTLETS_SUCCESS: (state, payload) => {
    state.editorOutlets.data = payload.data;
    state.editorOutlets.error = null;
  },
  LOAD_OUTLETS_FAIL: (state, payload) => {
    state.editorOutlets.data = null;
    state.editorOutlets.error = payload;
  }
};

const actions = {
  getOutlets: ({ commit, rootState }, { projectId, filterValues, pagination }) => {
    commit('LOAD_OUTLETS_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { 'Authorization': `Token token=${accessToken}` }
    };

    //in this case in pagination we will only have:searchQuery and perPage since this is a select list
    let query = '';
    if(pagination) {
      query = '?';
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }

    Axios
      .post(`${API_HOST}/analysis/editor/${projectId}/outlets${query}`, filterValues, config)
      .then(response => {
        commit('LOAD_OUTLETS_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_OUTLETS_FAIL', error)
      })
      .finally(() => commit('LOAD_OUTLETS_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};